import { getEnvValue } from '@env/getEnvValue'

enum ENVIRONMENT {
  DEVELOPMENT = 'development',
  HOMOLOGATION = 'homologation',
  PRODUCTION = 'production'
}

const NEXT_PUBLIC_ENVIRONMENT = getEnvValue(process.env.NEXT_PUBLIC_ENVIRONMENT)
const IS_DEVELOPMENT = NEXT_PUBLIC_ENVIRONMENT === ENVIRONMENT.DEVELOPMENT
const IS_HOMOLOGATION = NEXT_PUBLIC_ENVIRONMENT === ENVIRONMENT.HOMOLOGATION
const IS_PRODUCTION = NEXT_PUBLIC_ENVIRONMENT === ENVIRONMENT.PRODUCTION

const appEnv = {
  NEXT_PUBLIC_ENVIRONMENT,
  IS_DEVELOPMENT,
  IS_HOMOLOGATION,
  IS_PRODUCTION
}

export { appEnv }
